"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.TEXT_EDITOR_LANGUAGES = exports.LANGUAGES = void 0;
exports.LANGUAGES = {
    HY: 'hy',
    RU: 'ru',
    EN: 'en',
};
exports.TEXT_EDITOR_LANGUAGES = {
    description: 'hy',
    description_ru: 'ru',
    description_en: 'en',
};
exports.config = {
    language: 'en',
    // CKEditor 4 is end-of-life: without this every editor shows a red
    // "version is not secure" banner. The check only displays that notice.
    versionCheck: false,
    fontSize_defaultLabel: '0.85rem',
    toolbar: [
        {
            name: 'clipboard',
            items: ['Cut', 'Copy', 'Paste', 'Undo', 'Redo'],
        },
        {
            name: 'basicstyles',
            items: ['Bold', 'Italic', 'Underline', 'Strike', '-'],
        },
    ],
};
